import { MenuItem } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function ResolutionFilterMenuItem({ item }) {
    const { currentValue, onSelect } = useBoundContext()
    return (
        <MenuItem selected={item.value === currentValue} onClick={handleClick}>
            {item.label}
        </MenuItem>
    )

    function handleClick() {
        onSelect(item.value)
    }
}
